import { ReactElement, Suspense, useCallback } from 'react';
import SpringConfigs from 'utils/constants/swarm/spring-configs';
import { lazy } from 'utils/generic/lazy';
import { isMobile } from 'utils/is-mobile';
import { BetsManager } from 'newelements/_Betslip/managers/BetsManager';
import { BetslipConfigManager } from 'newelements/_Betslip/managers/ConfigManager';
import { CounterOfferManager } from 'newelements/_Betslip/managers/CounterOfferManager';
import { FreeBetManager } from 'newelements/_Betslip/managers/FreeBetManager';
import { OpenBetManager } from 'newelements/_Betslip/managers/OpenBetManager';
import { ProfitBoostManager } from 'newelements/_Betslip/managers/ProfitBoostManager';
import { QuickBetManager } from 'newelements/_Betslip/managers/QuickBetManager';
import { BetslipSetupManager } from 'newelements/_Betslip/managers/SetupManager';
import { useBetslipConfigsContext } from 'newelements/_Betslip/providers/configs-provider';

const { BetslipToggleManager: _BetslipToggleManager } = lazy(
  () =>
    import(
      /* webpackChunkName: "betslip-setup-manager-basic" */ 'newelements/_Betslip/managers/ToggleManager'
    )
);

export const RootManager = (): ReactElement => {
  const {
    static: { floatingMode }
  } = useBetslipConfigsContext();

  const BetslipToggleManager = useCallback((): ReactElement | null => {
    const isToggleable = floatingMode || isMobile();

    return isToggleable ? (
      <Suspense>
        <_BetslipToggleManager />
      </Suspense>
    ) : null;
  }, [floatingMode]);

  if (SpringConfigs.MOCKED_DATA) {
    return <BetslipSetupManager />;
  }

  return (
    <>
      <OpenBetManager />
      <QuickBetManager />
      <CounterOfferManager />
      <ProfitBoostManager />
      <FreeBetManager />
      <BetsManager />
      <BetslipToggleManager />
      <BetslipSetupManager />
      <BetslipConfigManager />
    </>
  );
};
